import * as PIXI from "pixi.js";

import "pixi-particles";
import "pixi-filters";
import "../libs/pixi-spine";
import "../libs/p3.min";
import 'joypad.js';

import Main from './Main';

var main = new Main(1024, 768);
main.init();
